import { render } from "./ApprovalsManager.vue?vue&type=template&id=a83b3c7c"
import script from "./ApprovalsManager.vue?vue&type=script&lang=js"
export * from "./ApprovalsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__